// MyNoMLMIncomeCredits.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import adimage1 from '../../assets/pageimages/roomanywhere/raindeximg1.png';
import adimage2 from '../../assets/navlogo.png';

const MyNoMLMIncomeCredits = () => {
  const authState = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/dashboard");
  };
  
  const { category } = useParams();

  const [showSample, setShowSample] = useState(false);

  const categoryTitles = {
    reselling: "Reselling Income Credits",
    content: "Content Creation Income Credits",
    authoring: "Authoring Income Credits",
    counselling: "Counselling Income Credits",
    consulting: "Consulting Income Credits",
    boutique: "Boutique Advisory Income Credits",
    franchise: "Franchise Income Credits",
    readfluencing: "Readfluencing Income Credits",
    internship: "Internship Income Credits",
    adview: "Ad View Income Credits",
    videoview: "Video View Income Credits",
    donations: "Donations Income Credits",
    institutional: "Institutional Income Credits",
    others: "Other Income Credits",
  };

  const heading = categoryTitles[category] || "Income Credits";

  // Dummy Sample Data
  const sampleCredits = {
    reselling: [
      { title: "Resold Digital Book: Practical Thinking Mathematics", credits: 50 },
      { title: "Resold Entrepreneurship Starter Kit", credits: 40 },
      { title: "Resold Think5Whys Learning Module", credits: 30 },
      { title: "Resold Personal Productivity Toolkit", credits: 35 },
    ],

    content: [
      { title: "Created Educational Video: Estimation Techniques", credits: 60 },
      { title: "Uploaded Podcast Episode: Practical Thinking", credits: 45 },
      { title: "Created Blog Post: Innovation Thinking", credits: 30 },
      { title: "Recorded Knowledge Sharing Session", credits: 40 },
    ],

    authoring: [
      { title: "Authored Book: Practical Thinking Mathematics", credits: 100 },
      { title: "Published Digital Learning Module", credits: 80 },
      { title: "Created Knowledge Course Series", credits: 90 },
    ],

    counselling: [
      { title: "Student Career Counselling Session", credits: 40 },
      { title: "Entrepreneur Guidance Session", credits: 50 },
      { title: "Academic Planning Consultation", credits: 35 },
    ],

    consulting: [
      { title: "Business Strategy Consulting", credits: 120 },
      { title: "Startup Growth Advisory", credits: 100 },
      { title: "Product Strategy Consultation", credits: 110 },
    ],

    boutique: [
      { title: "Premium Innovation Advisory", credits: 150 },
      { title: "DeepTech Startup Mentoring", credits: 170 },
      { title: "Strategic Transformation Consulting", credits: 160 },
    ],

    franchise: [
      { title: "Think5Whys Learning Center Franchise", credits: 200 },
      { title: "Digital Knowledge Hub Franchise", credits: 180 },
      { title: "Entrepreneurship Skill Lab Franchise", credits: 190 },
    ],

    readfluencing: [
      { title: "Promoted Book: Practical Thinking Mathematics", credits: 30 },
      { title: "Book Review Video Published", credits: 25 },
      { title: "Book Recommendation Campaign", credits: 20 },
    ],

    internship: [
      { title: "Startup Innovation Internship", credits: 60 },
      { title: "Digital Content Internship", credits: 50 },
      { title: "Research & Knowledge Internship", credits: 55 },
    ],

    adview: [
      { title: "Viewed Think5Whys Educational Ad", credits: 5 },
      { title: "Viewed Learning Platform Ad", credits: 4 },
      { title: "Viewed Innovation Startup Ad", credits: 5 },
    ],

    videoview: [
      { title: "Watched Knowledge Lecture Video", credits: 8 },
      { title: "Watched Innovation Podcast Video", credits: 7 },
      { title: "Watched Startup Education Video", credits: 9 },
    ],

    donations: [
      { title: "Donation to Knowledge Creation Fund", credits: 100 },
      { title: "Support for Student Scholarship Program", credits: 120 },
      { title: "Donation to Think5Whys Innovation Fund", credits: 150 },
    ],

    institutional: [
      { title: "University Knowledge Partnership", credits: 300 },
      { title: "Corporate Learning Collaboration", credits: 250 },
      { title: "Institutional Research Grant", credits: 280 },
    ],

    others: [
      { title: "Community Knowledge Contribution", credits: 20 },
      { title: "Innovation Idea Submission", credits: 25 },
      { title: "Platform Improvement Suggestion", credits: 15 },
    ],
  };

  const data = sampleCredits[category] || [];

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 [&_p]:text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">My Income Credits</div>
          <div className="text-[11px] text-gray-200">Think5Whys Micro Digital Income Initiative for the World!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}
      <div
        className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
        onClick={() => navigate("/roomanywhere")}
        >
            <div className="flex-shrink-0 w-20 h-20 rounded overflow-hidden bg-gray-700">
                <img
                src={adimage1} 
                alt="Ad"
                className="w-full h-full object-cover"
                />
            </div>
            <div className="flex flex-col text-left">
                <p className="text-xs uppercase text-gray-400 mb-1">Think5Whys Ad</p>
                <p className="font-semibold text-lg"><span className="text-yellow-200">RoomAnywhere</span>: Make Indoor and Outdoor Room (Patent Applied)</p>
                <p className="text-sm mt-1">Click to see more!</p>
            </div>
      </div>  

      {/* Heading */}
      <div className="text-center mt-2">
        <h1 className="text-yellow-200 text-lg lg:text-xl font-bold">
          {heading}
        </h1>

        <p className="text-gray-400 text-sm mt-1">
          Explore how income credits work in this category
        </p>
      </div>

      {/* Buttons */}
      <div className="flex gap-4 mt-2">

        <button
          disabled
          className="px-4 py-2 rounded bg-gray-700 text-gray-400 cursor-not-allowed"
        >
          My Credit
        </button>

        <button
          onClick={() => setShowSample(true)}
          className="px-4 py-2 rounded bg-teal-700 hover:bg-teal-600 text-white"
        >
          Sample Credit
        </button>

      </div>

      {/* Sample List */}
      {showSample && (
        <div className="w-full max-w-3xl mt-4">

          <div className="bg-gray-900 border border-gray-700 rounded-lg p-4">

            <h2 className="text-lg text-teal-300 mb-4">
              Example Credits in {heading}
            </h2>

            <div className="space-y-3">

              {data.map((item, index) => (
                <div
                  key={index}
                  className="flex justify-between items-center bg-black border border-gray-700 rounded p-3"
                >
                  <span className="text-gray-200">{item.title}</span>

                  <span className="text-yellow-200 font-semibold">
                    {item.credits} ₹
                  </span>
                </div>
              ))}

            </div>

          </div>

        </div>
      )}
      <div
        className="mt-4 p-3 border-2 border-dashed border-gray-500 rounded-lg bg-gray-900 text-gray-300 cursor-pointer hover:bg-gray-800 transition-all flex items-center gap-3"
        onClick={() => window.open("https://www.think5whys.com", "_blank")}
        >
        <div className="flex-shrink-0 w-16 h-16 bg-gray-700 rounded overflow-hidden">
            <img
                src={adimage2}
                alt="Ad"
                className="w-full h-full object-cover"
            />
            </div>

            <div className="flex flex-col text-left">
            <p className="text-xs uppercase text-gray-400 mb-1">Google Ad</p>
            <p className="font-semibold text-lg">Think5Whys: Your Platform for Transformation</p>
            <p className="text-sm mt-1">Click to see more!</p>
        </div>
      </div>         
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>    
    </div>
  );
};

export default MyNoMLMIncomeCredits;